export function getSuccessAppLaunchUrl() {
  //Remove if statement when mobile sdk migrate to new url
  return window.location.pathname === '/gov-trust/data'
    ? 'diva://gov-trust/myinfo'
    : 'diva:/' + window.location.pathname;
}
